import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=28187b45"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports